import type { HelpFile } from '../../types/help'
import { LdapConfigCardTestIds } from '../../../testids/LdapConfigCardTestIds'

export const ldapConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [LdapConfigCardTestIds.ldapConfigCard]:
      'LDAP connector configuration — server URL, bind credentials, and search base used to communicate with the directory.',
    [LdapConfigCardTestIds.cardTitleLdapConfig]: null,
    [LdapConfigCardTestIds.btnCreateLdapConfig]: null,
    [LdapConfigCardTestIds.btnEditLdapConfig]: null,
    [LdapConfigCardTestIds.bindPasswordRef]:
      'Reference to the LDAP bind password secret.',
    [LdapConfigCardTestIds.selectDirectoryDialect]:
      'Directory flavour. Active Directory emits userAccountControl=514/512 on DISABLE/ENABLE_ACCOUNT; OpenLDAP / 389-DS emits nsAccountLock=TRUE (or removed).',
    [LdapConfigCardTestIds.dlDirectoryDialect]: null,
  },
}
